export const authConstants = {
  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",

  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  LOGOUT: "USERS_LOGOUT",

  UPDATESESSION_REQUEST: "USERS_UPDATESESSION_REQUEST",
  UPDATESESSION_SUCCESS: "USERS_UPDATESESSION_SUCCESS",
  UPDATESESSION_FAILURE: "USERS_UPDATESESSION_FAILURE",

  FORGOTPASSWORD_REQUEST: "USERS_FORGOTPASSWORD_REQUEST",
  FORGOTPASSWORD_SUCCESS: "USERS_FORGOTPASSWORD_SUCCESS",
  FORGOTPASSWORD_FAILURE: "USERS_FORGOTPASSWORD_FAILURE",

  GET_USER_DATA_REQUEST: "GET_USER_DATA_REQUEST",
  GET_USER_DATA_SUCCESS: "GET_USER_DATA_SUCCESS",
  GET_USER_DATA_FAILURE: "GET_USER_DATA_FAILURE",

  ONBOARDING_LOGIN_EMAIL_REQUEST: "ONBOARDING_LOGIN_EMAIL_REQUEST",
  ONBOARDING_LOGIN_EMAIL_SUCCESS: "ONBOARDING_LOGIN_EMAIL_SUCCESS",
  ONBOARDING_LOGIN_EMAIL_FAILURE: "ONBOARDING_LOGIN_EMAIL_FAILURE"
};



// WEBPACK FOOTER //
// ./src/store/constants/auth.constants.js